import { atom } from "jotai";

/**
 * Interface representing the global application state.
 * Contains properties related to authentication, API configuration,
 * user information, and application settings.
 */
interface AppState {
  initialised: boolean; // Whether the app has completed initialization
  APIEndpoint: string; // Main API endpoint URL
  APIEndpointProcessor: string; // Processor API endpoint URL
  stripeKey: string; // Stripe API key for payment processing
  myUrl: string; // Application URL
  loading: boolean; // Global loading state
  username?: string; // Current user's username if authenticated
  authed: boolean; // Whether user is authenticated
  errorMessage?: string; // Global error message
  user?: any; // User object containing user data
  subscriptionActive: boolean; // Whether user has an active subscription
  gridTheme: string; // Theme for data grid components
  role: string; // User role (e.g., "user", "admin")
  stripeId?: string; // User's Stripe customer ID
  featureFlags?: string[]; // Feature flags for enabling/disabling features
  email?: string; // User's email address
}

/**
 * Builds the initial application state with default values.
 * Sets different configuration based on environment (development vs production).
 *
 * @returns {AppState} The initial application state
 */
const buildInitialState = (): AppState => {
  const state: any = {
    initialised: false,
    loading: false,
    authed: false,
    subscriptionActive: false,
    role: "user",
    featureFlags: [],
    gridTheme: "wb-ag-theme",
  };

  if (
    process.env.NODE_ENV === "dev" ||
    process.env.NODE_ENV === "development"
  ) {
    console.log("Dev environment");
    state.stripeKey = "";
  } else {
    state.stripeKey = "";
  }

  return state;
};

/**
 * Jotai atom for storing and managing global application state.
 * This is the main state container for the WealthBee application.
 */
export const AppStateAtom = atom<AppState>(buildInitialState());
